// extracted by mini-css-extract-plugin
export default {"page__body":"ReportsHome_page__body__qgSN+","page__content":"ReportsHome_page__content__85Y2u","ReportsMainBox":"ReportsHome_ReportsMainBox__4cld-"};